function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_792",
  "data-name": "Rectangle 792",
  transform: "translate(817 703)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0.12)",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 199,
  height: 44,
  rx: 22,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 198,
  height: 43,
  rx: 21.5,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic_google",
  transform: "translate(834 713)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M20.52,9.818A13.789,13.789,0,0,0,20.3,7.364H9v4.642h6.458a5.52,5.52,0,0,1-2.395,3.622v3.011h3.878a11.7,11.7,0,0,0,3.578-8.82Z",
  transform: "translate(3 2.455)",
  fill: "#4285f4",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M11.681,20.43a11.456,11.456,0,0,0,7.942-2.907l-3.878-3.011a7.24,7.24,0,0,1-10.778-3.8H.957v3.109A12,12,0,0,0,11.681,20.43Z",
  transform: "translate(0.319 3.57)",
  fill: "#34a853",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-3",
  "data-name": "Shape",
  d: "M5.285,12.627a7.094,7.094,0,0,1,0-4.56V4.958H1.276a12.015,12.015,0,0,0,0,10.778l4.009-3.109Z",
  transform: "translate(0 1.653)",
  fill: "#fbbc05",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-4",
  "data-name": "Shape",
  d: "M11.681,4.773a6.483,6.483,0,0,1,4.587,1.795L19.71,3.125A11.533,11.533,0,0,0,11.681,0,12,12,0,0,0,.957,6.611L4.966,9.72a7.152,7.152,0,0,1,6.715-4.947Z",
  transform: "translate(0.319)",
  fill: "#ea4335",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-5",
  "data-name": "Shape",
  d: "M0,0H24V24H0Z",
  fill: "none",
  fillRule: "evenodd"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1517",
  "data-name": "Path 1517",
  d: "M66.516,26.563a4.069,4.069,0,0,1-1.789,1.175,7.485,7.485,0,0,1-2.563.418,5.074,5.074,0,0,1-2.59-.644,4.308,4.308,0,0,1-1.719-1.871,6.6,6.6,0,0,1-.621-2.883v-.773a6.993,6.993,0,0,1,.575-2.95,4.241,4.241,0,0,1,1.656-1.906,5.453,5.453,0,0,1,5.7.305,4.125,4.125,0,0,1,1.352,2.808H64.234a2.266,2.266,0,0,0-.691-1.429,2.21,2.21,0,0,0-1.473-.453,2.077,2.077,0,0,0-1.82.9,4.719,4.719,0,0,0-.633,2.672v.726a4.5,4.5,0,0,0,.68,2.7,2.328,2.328,0,0,0,1.992.914,2.6,2.6,0,0,0,1.883-.563V23.75H62.039V22.024h4.477Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1518",
  "data-name": "Path 1518",
  d: "M67.914,23.7a5.016,5.016,0,0,1,.484-2.243,3.544,3.544,0,0,1,1.395-1.523,4.069,4.069,0,0,1,2.113-.539A3.844,3.844,0,0,1,74.7,20.438a4.2,4.2,0,0,1,1.207,2.843l.016.579a4.421,4.421,0,0,1-1.086,3.121,4.211,4.211,0,0,1-5.832,0,4.5,4.5,0,0,1-1.09-3.188Zm2.258.16a3.156,3.156,0,0,0,.453,1.842,1.627,1.627,0,0,0,2.578.008,3.46,3.46,0,0,0,.461-2.014,3.128,3.128,0,0,0-.461-1.831,1.5,1.5,0,0,0-1.3-.65,1.472,1.472,0,0,0-1.281.646A3.514,3.514,0,0,0,70.172,23.856Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1519",
  "data-name": "Path 1519",
  d: "M76.961,23.7a5.016,5.016,0,0,1,.484-2.243A3.544,3.544,0,0,1,78.84,19.93a4.069,4.069,0,0,1,2.113-.539,3.845,3.845,0,0,1,2.793,1.047,4.2,4.2,0,0,1,1.207,2.843l.016.579a4.426,4.426,0,0,1-1.086,3.121,4.211,4.211,0,0,1-5.832,0,4.5,4.5,0,0,1-1.09-3.188Zm2.258.16a3.156,3.156,0,0,0,.453,1.842,1.627,1.627,0,0,0,2.578.008,3.46,3.46,0,0,0,.461-2.014,3.128,3.128,0,0,0-.461-1.831,1.5,1.5,0,0,0-1.3-.65,1.472,1.472,0,0,0-1.281.646A3.514,3.514,0,0,0,79.219,23.856Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1520",
  "data-name": "Path 1520",
  d: "M86.031,23.711a4.956,4.956,0,0,1,.926-3.133,3,3,0,0,1,2.5-1.187,2.628,2.628,0,0,1,2.164.953l.094-.8h2.047v8.172a3.615,3.615,0,0,1-.5,1.93,3.235,3.235,0,0,1-1.418,1.25,4.991,4.991,0,0,1-2.141.429,4.637,4.637,0,0,1-1.812-.371A3.207,3.207,0,0,1,86.547,30l1-1.375a2.646,2.646,0,0,0,2.047.946,1.937,1.937,0,0,0,1.4-.481,1.8,1.8,0,0,0,.5-1.363v-.453a2.61,2.61,0,0,1-2.054.882,2.991,2.991,0,0,1-2.465-1.191,4.951,4.951,0,0,1-.942-3.16Zm2.258.16a3.1,3.1,0,0,0,.461,1.81,1.466,1.466,0,0,0,1.266.655,1.566,1.566,0,0,0,1.476-.777V21.988a1.563,1.563,0,0,0-1.461-.777,1.474,1.474,0,0,0-1.277.667A3.5,3.5,0,0,0,88.289,23.871Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1521",
  "data-name": "Path 1521",
  d: "M97.875,28H95.609V16h2.266Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1522",
  "data-name": "Path 1522",
  d: "M103.625,28.156a4.144,4.144,0,0,1-3.027-1.14,4.055,4.055,0,0,1-1.168-3.039v-.219a5.106,5.106,0,0,1,.492-2.277,3.616,3.616,0,0,1,1.394-1.547,3.907,3.907,0,0,1,2.059-.543,3.5,3.5,0,0,1,2.73,1.094,4.438,4.438,0,0,1,1,3.1v.922h-5.383a2.093,2.093,0,0,0,.66,1.328,2,2,0,0,0,1.394.5,2.437,2.437,0,0,0,2.039-.945l1.11,1.242a3.384,3.384,0,0,1-1.375,1.121A4.5,4.5,0,0,1,103.625,28.156Zm-.258-6.945a1.413,1.413,0,0,0-1.09.455,2.356,2.356,0,0,0-.535,1.3h3.141v-.181a1.69,1.69,0,0,0-.406-1.165A1.461,1.461,0,0,0,103.367,21.211Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1523",
  "data-name": "Path 1523",
  d: "M116.126,18.645a7.922,7.922,0,0,0,1.36-1.729h-3.632V15.379h5.521v1.249a8.91,8.91,0,0,1-1.488,2.5h3.968a13.059,13.059,0,0,1-2.288-3.441l1.393-.769a10.632,10.632,0,0,0,.912,1.681,8.718,8.718,0,0,0,1.44-1.441l1.169,1.041a9.613,9.613,0,0,1-1.712,1.6,7.5,7.5,0,0,0,.864.9,9.138,9.138,0,0,0,1.713-1.713L126.514,18a9.847,9.847,0,0,1-1.7,1.665,16.584,16.584,0,0,0,2.337,1.425l-1.1,1.28a17.623,17.623,0,0,1-3.265-2.321v.593H116.91v-.513a13.663,13.663,0,0,1-3.793,2.273l-1.025-1.312a13.341,13.341,0,0,0,2.865-1.489,18.486,18.486,0,0,0-1.889-1.489l1.121-1.056A21.388,21.388,0,0,1,116.126,18.645Zm1.969,9.092h3.025a13.942,13.942,0,0,0,1.169-1.906l1.552.561a14.3,14.3,0,0,1-.912,1.345h3.489v1.584H112.557V27.737h3.761a8.655,8.655,0,0,0-1.185-1.265l1.569-.593A9.808,9.808,0,0,1,118.1,27.737Zm6.066-6.115v4.161h-9.252V21.622Zm-1.681,1.456h-5.89v1.233h5.89Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1524",
  "data-name": "Path 1524",
  d: "M132.686,17.028V15.4h3.57a19.383,19.383,0,0,0,6.562,12.741l-.961,1.44a20.628,20.628,0,0,1-6.273-9.908,17.638,17.638,0,0,1-6.483,9.876l-1.025-1.44A18.144,18.144,0,0,0,134.9,17.028Z",
  fill: "rgba(0,0,0,0.6)"
});

var SvgSignInWithGoogle = function SvgSignInWithGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 44,
    viewBox: "0 0 199 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "sign-in-with-google",
    transform: "translate(-817 -703)"
  }, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "Google_\\u767B\\u5165",
    "data-name": "Google \\u767B\\u5165",
    transform: "translate(825.766 702.085)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    style: {
      isolation: "isolate"
    }
  }, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    style: {
      isolation: "isolate"
    }
  }, _ref10, _ref11))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignInWithGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-in-with-google.bc33835f.svg";
export { ForwardRef as ReactComponent };